export const debunks = [
  {
    title: "「某食品大量使用工业防腐剂」流传截图查无实据",
    claim: "一张标注模糊的检测截图被反复转发，配文称某热销食品防腐剂超标数倍。",
    fact:
      "经比对配方备案与第三方抽检报告，未发现违规记录，所谓「检测」截图来源不明、无出具机构。",
    tags: ["食品安全", "截图存疑"],
    date: "2026-09-05",
  },
  {
    title: "「某景区闭园改造是永久关门」属过度解读",
    claim: "网传公告截图称某知名景区「无限期闭园」，引发大量退票与担忧。",
    fact:
      "原文实为「分区分批改造施工」，官方同步发布恢复开放计划，与「永久关门」表述相去甚远。",
    tags: ["旅游出行", "断章取义"],
    date: "2026-08-30",
  },
  {
    title: "「某饮料含争议成分」旧闻被重新包装成新料",
    claim: "一段标注为「最新曝光」的视频在社交平台传播，称某饮料含争议成分。",
    fact:
      "画面素材来自数年前的旧报道，成分与现行标准早已调整，旧闻新发属常见炒作手法。",
    tags: ["食品饮料", "旧闻新炒"],
    date: "2026-08-24",
  },
];

export const evidenceDossiers = [
  {
    icon: "ri-link",
    title: "原始出处",
    note: "锚定内容最早出现的平台、账号与时间",
  },
  {
    icon: "ri-file-copy-2-line",
    title: "上下文还原",
    note: "找回被裁剪的前后文，判断是否断章取义",
  },
  {
    icon: "ri-shield-keyhole-line",
    title: "官方回应",
    note: "收录当事机构公开声明与可查证记录",
  },
  {
    icon: "ri-stack-line",
    title: "版本留档",
    note: "记录内容修改与删除痕迹，便于回溯",
  },
];